import type { SYSState } from "../../../../_ovlclient/src"
import { html, SYSConfig, render } from "../../../../_ovlclient/src"
export let startRender = async (state: SYSState) => {
  console.log(
    `itflies kalt ag portal ${SYSConfig._system.versionInfo.frontend.app.version} is initialised and is starting...`
  )

  await render(
    html` <comp-sysshellbar></comp-sysshellbar> `,
    document.getElementById("app")
  )
}
